if (!customElements.get('campaign-countdown-banner')) {
  customElements.define(
    'campaign-countdown-banner',
    class CampaignCountdownBanner extends HTMLElement {
      constructor() {
        super();
        this.campaignEndDate = this.dataset.campaignEnd;
        this.daysElement = this.querySelector('.campaign-countdown-days');
        this.textElement = this.querySelector('.campaign-countdown-text');
        this.labelElement = this.querySelector('.campaign-countdown-label');
        
        // Store original text content for restoration
        if (this.textElement) {
          this.originalText = this.textElement.textContent;
        }
        if (this.labelElement) {
          this.originalLabel = this.labelElement.textContent;
        }
        
        if (this.campaignEndDate && this.daysElement) {
          this.calculateAndDisplayCountdown();
        }
      }
      
      calculateAndDisplayCountdown() {
        try {
          // Parse the campaign end date (format: 'YYYY-MM-DD HH:mm:ss.SSS Z')
          // Convert to ISO 8601 for Safari compatibility
          let isoDateString = this.campaignEndDate
            .replace(' ', 'T') // Replace space between date and time with 'T'
            .replace(/\s([+-]\d{2}:?\d{2})$/, '$1'); // Remove space before timezone if present

          // If milliseconds are missing, add .000
          if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(isoDateString)) {
            isoDateString += '.000';
          }

          const endDate = new Date(isoDateString);
          const now = new Date();
          
          // Calculate difference in milliseconds
          const timeDiff = endDate.getTime() - now.getTime();
          
          // If campaign has ended, hide banner
          if (timeDiff <= 0) {
            this.style.display = 'none';
            return;
          }
          
          // Calculate days remaining
          const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));


          
          console.log('timeDiff', timeDiff);
          console.log('daysRemaining', timeDiff / (1000 * 60 * 60 * 24));
          // Update display based on days remaining
          if (timeDiff / (1000 * 60 * 60 * 24) < 1) {
            // Show midnight message when less than 1 day remaining
            const midnightText = window.campaignCountdownStrings?.priceEndsAtMidnight || 'Price ends at midnight';
            this.textElement.textContent = midnightText;
            this.daysElement.textContent = '';
            this.labelElement.textContent = '';
          } else {
            // Show normal countdown display
            this.daysElement.textContent = daysRemaining;
            // Restore original text if it was changed from midnight message
            const midnightText = window.campaignCountdownStrings?.priceEndsAtMidnight || 'Price ends at midnight';
            if (this.textElement.textContent === midnightText) {
              this.textElement.textContent = this.originalText || '';
              this.labelElement.textContent = this.originalLabel || '';
            }
          }
          
          // Show banner
          if(daysRemaining != NaN) {
            this.style.display = 'inline-flex';
          }
          
        } catch (error) {
          console.error('Error calculating campaign countdown:', error);
          this.style.display = 'none';
        }
      }
    }
  );
}